<template>
  <div :class="leadKey ? 'w-50' : 'w-100'" class="mt-12px">
    <div class="half-graph-container">
      <div
        class="
          d-flex
          justify-content-between
          align-items-center
          border-bottom
          px-2
          pb-2
        "
      >
        <div class="dashboardAdmin-cards-head ml-2">Vendor Report</div>
        <div
          class="mr-2 pointer"
          @click="goToVendor()"
          v-if="roles.includes('GET_REPORT_VENDOR')"
        >
          <img
            src="../../assets/New-imgs/landing-dashboard/redirect.svg"
            alt=""
          />
        </div>
      </div>
      <div
        style="margin: auto"
        v-if="vendSpinner"
        class="d-flex justify-content-center align-items-center h-100"
      >
        <b-spinner label="Loading..."></b-spinner>
      </div>
      <div
        v-else-if="!vendSpinner && noVendorDataPercent"
        class="d-flex align-items-center justify-content-center w-100 h-100"
      >
        <img src="../../assets/ReportsNew/recDashboardNodata.svg" alt="" />
      </div>
      <!-- <div v-else id="vendGraph"></div> -->

      <div v-else class="d-flex h-90">
        <div style="width: 80%" class="h-100">
          <div id="vendGraph" style="width: 100%; height: 100%"></div>
        </div>
        <div
          style="width: 20%"
          class="h-100 d-flex align-items-start justify-content-end m-3"
        >
          <div class="legend-container">
            <div
              class="d-flex align-items-center"
              v-for="(data, i) in vendorTransformData"
              :key="i + 'venData'"
            >
              <!-- :style="{ backgroundColor: data.colourCode }" -->
              <div
                class="legend-color-circle mr-1"
                :style="{ backgroundColor: data.colour }"
              ></div>
              <div class="legend-heading">{{ data.name }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { thirdPartyBar } from "vue-d3-charts-hire3x";
import { mapGetters } from "vuex";
import { vendorGraphDash } from "../../utils/apiFunctions";
import { recAndVend } from "vue-d3-charts-hire3x";

export default {
  created() {
    this.getVendStats();
  },
  props: {
    leadKey: Boolean,
  },
  computed: {
    ...mapGetters(["roles"]),

    ...mapGetters("userVUEX", {
      roleValues: "getRoleValues",
      projectUsers: "getProjectUsers",
    }),
  },
  data() {
    return {
      vendSpinner: true,
      vendorTransformData: [],
      noVendorDataPercent: true,
      loopvar: 2,
    };
  },
  methods: {
    goToVendor() {
      this.$router.push({
        name: "VendorReport",
        query: {
          status: "dashboard",
        },
      });
    },
    areAllCountsZero(data, property) {
      return data.every((item) => item[property] === 0);
    },
    // async getVendStats() {
    //   try {
    //     const payload = {
    //       userID: this.roleValues.userID,
    //     };
    //     const response = await vendorGraphDash(payload);
    //     console.log(response);
    //     if (response.status == 200) {
    //       const fixedResp = response.data.data;
    //       const colors = ["#F5D06E", "#4070EA", "#269C8A", "#595959"];
    //       if (fixedResp.length > 0) {
    //         let name = this.projectUsers;
    //         this.vendorTransformData = fixedResp.map((item, i) => {
    //           if (name[item._id]) {
    //             return {
    //               name: name[item._id].username,
    //               count: item.selectionRate,
    //               colour: colors[i],
    //             };
    //           }
    //         });
    //         this.noVendorDataPercent = this.areAllCountsZero(
    //           fixedResp,
    //           "selectionRate"
    //         );
    //         setTimeout(() => {
    //           if (document.getElementById("vendGraph").innerHTML != "") {
    //             document.getElementById("vendGraph").innerHTML = "";
    //           }

    //           let recStats = new recAndVend();
    //           const xAxisText = "Vendors";
    //           recStats.verticalGraph(
    //             "#vendGraph",
    //             colors,
    //             this.vendorTransformData,
    //             xAxisText
    //           );
    //         }, 200);
    //       }
    //     } else {
    //       console.log("API ERROR");
    //     }
    //   } catch (error) {
    //     console.error(error);
    //   }
    //   this.vendSpinner = false;
    // },

    async getVendStats() {
      try {
        const payload = {
          userID: this.roleValues.userID,
        };
        const response = await vendorGraphDash(payload);

        if (response.status == 200) {
          const fixedResp = response.data.data;
          const colors = ["#F5D06E", "#4070EA", "#269C8A", "#595959"];
          if (fixedResp.length > 0) {
            let name = this.projectUsers;
            this.vendorTransformData = fixedResp.map((item, i) => {
              if (name[item._id]) {
                return {
                  name: name[item._id].username,
                  count: item.selectionRate,
                  colour: colors[i],
                };
              }
            });
            this.noVendorDataPercent = this.areAllCountsZero(
              fixedResp,
              "selectionRate"
            );
            setTimeout(() => {
              if (document.getElementById("vendGraph").innerHTML != "") {
                document.getElementById("vendGraph").innerHTML = "";
              }

              if (this.leadKey) {
                let recStats = new recAndVend();
                const xAxisText = "Vendors";
                recStats.verticalGraph(
                  "#vendGraph",
                  colors,
                  this.vendorTransformData,
                  xAxisText
                );
              } else {
                const xAxisText = "Selection Rate(in %)";
                let width = 1200;
                let height = 290;
                let component = "recruiterDash";
                let e = new thirdPartyBar();
                e.horizontalBarGraph(
                  this.vendorTransformData,
                  "#vendGraph",
                  width,
                  height,
                  xAxisText,
                  colors,
                  component
                );
              }
            }, 200);
          }
        }
      } catch (error) {
        console.error(error);
      }
      this.vendSpinner = false;
    },
  },
};
</script>

<style lang="postcss" scoped></style>
